import React, { Suspense, lazy } from "react";
import "./App.css";
import { createBrowserRouter } from "react-router-dom";
import FullPageLoader from "./Components/FullPageLoader";
import Layout from "./Layout";

const Home = lazy(() => import("./Home"));
const About = lazy(() => import("./About"));
const Contact = lazy(() => import("./Contact"));
const ScriptList = lazy(() => import("./Script/scriptList"));
const ScriptDetails = lazy(() => import("./Script/scriptDetails"));
const ScriptDownloads = lazy(() => import("./Script/scriptDownloads"));
const SubmissionStatus = lazy(() => import("./SubmissionStatus"));

const router = createBrowserRouter([
  {
    path: "",
    element: <Layout />,
    children: [
      {
        path: "home",
        element: (
          <Suspense fallback={<FullPageLoader />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: "about-us",
        element: (
          <Suspense fallback={<FullPageLoader />}>
            <About />
          </Suspense>
        ),
      },
      {
        path: "scripts",
        element: (
          <Suspense fallback={<FullPageLoader />}>
            <ScriptList />
          </Suspense>
        ),
      },
      {
        path: "scripts/:scriptName",
        element: (
          <Suspense fallback={<FullPageLoader />}>
            <ScriptDetails />
          </Suspense>
        ),
      },
      {
        path: "/download/:scriptRoute",
        element: (
          <Suspense fallback={<FullPageLoader />}>
            <ScriptDownloads />
          </Suspense>
        ),
      },
      {
        path: "contact",
        element: (
          <Suspense fallback={<FullPageLoader />}>
            <Contact />
          </Suspense>
        ),
      },
      {
        path: "status",
        element: (
          <Suspense fallback={<FullPageLoader />}>
            <SubmissionStatus />
          </Suspense>
        ),
      },
    ],
  },
]);

export default router;
